import { render, staticRenderFns } from "./SerialsTable.vue?vue&type=template&id=88b7b3b8"
import script from "./SerialsTable.vue?vue&type=script&lang=js"
export * from "./SerialsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports